// extracted by mini-css-extract-plugin
export default {"wrapperClass":"Ln1Azy9g3YaOiJSiDx3g"};